import React, { Component } from 'react';
import { connect } from 'react-redux';

class HomePage extends Component {
    render() {
        return (
            <h1>Home Page</h1>
        )
    }
}

export default connect()(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js